"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const translate_1 = require("components/translate");
const PublishedBadge = ({ t }) => {
    return ((0, jsx_runtime_1.jsxs)("span", { className: "_d-flex _align-items-center _text-1 _text-gray-500", children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'check'], className: "_mr-1 _text-1" }), (0, jsx_runtime_1.jsx)("span", { children: t('content_list.published') })] }));
};
exports.default = (0, translate_1.translate)()(PublishedBadge);
